<script lang="ts" setup>
interface IProps {
  bgColor?: string
  maxHeight?: string
}

const props = withDefaults(defineProps<IProps>(), {
  bgColor: 'bg-white',
  maxHeight: '12rem',
})

const { bgColor } = toRefs(props)
</script>

<template>
  <div
    z-999 overflow-y-auto
    shadow-sm border border-softGray rounded-2
    class="default:p-5" :class="[bgColor]"
    :style="{ maxHeight }"
  >
    <slot />
  </div>
</template>
